'use client';

import Image from 'next/image';
import Link from 'next/link';

import { staticMediaUrl } from '@/fo/util/image-loader';
import { reachMetrikaGoal } from '@/fo/util/metrics';

import { styles } from './BuyNow.styles';

export interface BuyNowProps {
  className?: string;
  isNearFooter?: boolean;
}

export function BuyNow({ className, isNearFooter = false }: BuyNowProps) {
  const slots = styles();

  return (
    <div className={slots.base({ className })}>
      {!isNearFooter && (
        <Link
          href="/catalog/bioderma/gammy/sensibio/"
          className={slots.image()}
          onClick={() => {
            reachMetrikaGoal('knopka_kupit_seychas_kruglyash');
          }}
        >
          <Image
            src={staticMediaUrl('landing/bioderma_galchonok/buy-now.png')}
            alt="Купить сейчас"
            width={168}
            height={168}
          />
        </Link>
      )}
    </div>
  );
}
